import React from "react";
import {css} from "@emotion/react";
import {Button} from "@web2/button";

import {fullWidthViewHolder} from "../../login/view/LoginView";

export const logoGhWhite = require("../../app/img/logo_gh_white.svg");

export const NotFoundView = () => {
    return (
        <div css={fullWidthViewHolder}>
            <div css={errorMessageBox}>
                <div css={logoHolder} />

                <div css={errorMessageInfoHolder}>
                    <h2 css={errorMessageHeading}>Szukana przez Ciebie strona nie istnieje</h2>

                    <Button variant="primary" onClick={() => history.back()}>
                        Wróć do poprzedniej strony
                    </Button>
                </div>
            </div>
        </div>
    );
};

const errorMessageBox = css`
    display: flex;
    flex-direction: row;
    align-items: center;
`;

const logoHolder = css`
    background-image: url(${logoGhWhite});
    background-repeat: no-repeat;
    background-position: center center;
    background-size: contain;
    width: 220px;
    height: 50px;
`;

const errorMessageInfoHolder = css`
    margin-left: 4rem;
    padding: 3rem 0 3rem 4rem;
    border-left: 1px solid #fff;
    color: #fff;
`;

const errorMessageHeading = css`
    font-size: 2.8rem;
    margin-top: 0;
`;
